<script setup>

    const props = defineProps({
        variant: {
            type: String,
            default: 'default', // 'small'
        }
    })

</script>

<template>

    <template v-if="props.variant === 'small'">
        <div class="size-6 flex aspect-square justify-center object-center">
            <div style="border-top-color:transparent" class="size-6 border-2 border-white border-dotted rounded-full animate-spin" />
        </div>
    </template>

    <template v-else-if="props.variant === 'default'">
        <div class="w-32 mx-auto flex justify-center object-center">
            <div style="border-top-color:transparent" class="w-12 h-12 border-4 border-lifeworx-blue-400 border-dotted rounded-full animate-spin"></div>
        </div>
    </template>

</template>
